import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { Foto } from './../../model/foto';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { Linhadotempo } from '../../model/linhadotempo';
import { LinhadotempoService } from '../../service/linhadotempo.service';

@Component({
  selector: 'app-admin-timeline-form',
  templateUrl: './admin-timeline-form.component.html',
  styleUrls: ['./admin-timeline-form.component.css']
})
export class AdminTimelineFormComponent implements OnInit {

  item: Linhadotempo;
  uploadPercent: Observable<number>;
  fotoNova: Foto = null;

  constructor(private route: ActivatedRoute, private service: LinhadotempoService, private messageService: MessageService) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.has('id')) {
      const id = this.route.snapshot.paramMap.get('id');
      this.service.find(id).subscribe(ret => {
        this.item = ret;
      });
    } else {
      this.item = <Linhadotempo>{};
      this.item.id = this.service.criaId();
    }
  }

  salvar() {
    const task = this.service.salvar(this.item);
    task.then(ret => {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Salvo com Sucesso' });
    }).catch(e => {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar' });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-timeline-form/admin-timeline-form.component.ts